import React from 'react';
import { Col } from 'reactstrap';
import DataTable from '../../../../../components/Core/DataTable';
import { PagedMetaInterface } from '../../../../../entities/PagedMeta';

interface RaisesTabProps {
  columns: any[];
  data: any[];
  pagedMeta: PagedMetaInterface;
  loading: boolean;
  handlePerRowsChange: (perPage: number) => Promise<void>;
  handlePageChange: (page: number) => Promise<void>;
}

const RaisesTab = ({ columns, data, pagedMeta, loading, handlePerRowsChange, handlePageChange }: RaisesTabProps) => {
  return (
    <Col xs="12">
      <DataTable
        columns={columns}
        data={data}
        header={false}
        totalRows={pagedMeta.total}
        loading={loading}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />
    </Col>
  );
};

export default RaisesTab;
